var url= 'edunex.co.il';
// var url= 'localhost:8000';
var api_port = ""
export const SystemApp={

   base_url: `https://api.${url}/`,
   base_url_api: `https://api.${url}`,
   web_socket: `ws://${url}/ws/`

  // base_url: `http://${url}`,
  // base_url_api: `http://${url}${api_port}`,
  // web_socket: `ws://${url}/ws/`
}
